@if (isLoading) {
  <div class="spin-outer" style="z-index: 1000 !important;">
    <div class="spin-container">
      <div class="spin-inner">
        <div class="spin-cube-grid" >
          <div class="spin-cube spin-cube1"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/1.jpg');  background-size: cover;">
          </div>
          <div class="spin-cube spin-cube2"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/2.jpg');  background-size: cover;">
          </div>
          <div class="spin-cube spin-cube3"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/3.jpg');  background-size: cover;">
          </div>
          <div class="spin-cube spin-cube4"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/4.jpg');  background-size: cover;">
          </div>
          <div class="spin-cube spin-cube5"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/5.jpg'); background-size: cover;">
          </div>
          <div class="spin-cube spin-cube6"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/6.jpg'); background-size: cover;">
          </div>
          <div class="spin-cube spin-cube7"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/7.jpg'); background-size: cover;">
          </div>
          <div class="spin-cube spin-cube8"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/8.jpg'); background-size: cover;">
          </div>
          <div class="spin-cube spin-cube9"
            style="background: url('assets/img/logo/lynxfleet/LYNX-loading/9.jpg'); background-size: cover;">
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- <div *ngIf="isLoading" class="global-loader-overlay">
<div class="loader-container">
  <div class="spinner"></div>
  <p>Loading... ({{activeRequestsCount}} requests)</p>
</div>
</div> -->